import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import AOS from "aos";
import "aos/dist/aos.css";
import { all_routes } from "../router/all_routes";
import { groupPackagesForDisplay } from "../package/packageGrouping";
import { getPackageUrl } from "../package/packageSeo";
import PhoneNumberField from "./phoneNumberField";
import { API_BASE_URL, CLIENT_BASE_PATH } from "../../environment";
import axios from "axios";
import ProductCardLoader from "../common/loaders/product-card-loader";
import CardIconLoader from "../common/loaders/card-icon-loader";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { setMeta } from "../../core/data/utils/meta";
import { buildTaxiServiceSchema } from "../../core/data/utils/schema";
import { addCartItem, packageToCartItem } from "../cart/cartUtils";
import { useSelector } from "react-redux";

const getArrayPayload = (payload: any) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  return [];
};

const buildVehicleTypeFallback = (packages: any[]) => {
  const vehicleTypes = new Map();

  packages.forEach((packageItem: any) => {
    const vehicleType = packageItem?.vehicle_detail?.vehicle_type;

    if (vehicleType?.id && !vehicleTypes.has(vehicleType.id)) {
      vehicleTypes.set(vehicleType.id, vehicleType);
    }
  });

  return Array.from(vehicleTypes.values());
};

const POPULAR_OFFERS_PAGE_SIZE = 6;

const ArHome = () => {
  const routes = all_routes;
  const user = useSelector((state: any) => state.auth?.user || {});
  const token = useSelector((state: any) => state.auth?.token || "");
  const [selectedItems, setSelectedItems] = useState(Array(10).fill(false));
  const [popularCartTypes, setPopularCartTypes] = useState([]);
  const [vehicleTypeList, setVehicleTypeList] = useState([]);
  const [packagesList, setPackagesList] = useState([]);
  const [locationsList, setLocationsList] = useState([]);
  const [confirmBookingData, setConfirmBookingData] = useState<any>([]);
  const [activeIndex, setActiveIndex] = useState<number | null>(-1);
  const [isloading, setIsLoading] = useState(false);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [bookingConfirmToggle, setBookingConfirmToggle] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedVehicle, setSelectedVehicle] = useState<string>("");
  const [selectedPickupLocation, setSelectedPickupLocation] = useState<string>("");
  const [selectedDropLocation, setSelectedDropLocation] = useState<string>("");
  const [packagePriceData, setPackagePriceData] = useState<any>([]);
  const [cartMessage, setCartMessage] = useState("");
  const [showBookingDetails, setShowBookingDetails] = useState(false);
  const [offersPage, setOffersPage] = useState(1);
  const [activeVehicleType, setActiveVehicleType] = useState("");
  const displayName = [user?.firstname, user?.lastname].filter(Boolean).join(" ") || user?.name || user?.username || "";
  const userEmail = user?.email || "";
  const userPhone = user?.phone_no || user?.phone || user?.mobile || "";
  const isLoggedIn = Boolean(token && userEmail);
  const totalAmount = Number(confirmBookingData?.vehicle_detail?.price || 0);
  const formattedTotalAmount = totalAmount
    ? `${totalAmount.toLocaleString()} ريال`
    : "0 ريال";
  const groupedPackagesList = groupPackagesForDisplay(packagesList);
  const totalOffersPages = Math.max(1, Math.ceil(groupedPackagesList.length / POPULAR_OFFERS_PAGE_SIZE));
  const paginatedPackagesList = groupedPackagesList.slice(
    (offersPage - 1) * POPULAR_OFFERS_PAGE_SIZE,
    offersPage * POPULAR_OFFERS_PAGE_SIZE
  );
  const displayCartTypes = popularCartTypes.length > 0 ? popularCartTypes : buildVehicleTypeFallback(packagesList);

  useEffect(() => {
    const canonicalUrl = `${CLIENT_BASE_PATH}/ar`;
    const title = "خدمة تاكسي للحج والعمرة في السعودية | الحرمين كاب";
    const description = "الحرمين كاب خدمة تاكسي موثوقة للحج والعمرة في السعودية. الخيار الأول لمعتمري وحجاج بيت الله الحرام. احجز رحلتك الآن!";
    setMeta(
      title,
      description,
      canonicalUrl,
      `${CLIENT_BASE_PATH}/assets/img/banner.jpg`,
      {
        keywords: "تاكسي الحج السعودية, خدمة تاكسي العمرة, تاكسي من مكة إلى المدينة, نقل مطار جدة, تاكسي الزيارة, الحرمين كاب",
        locale: "ar",
        alternateUrl: CLIENT_BASE_PATH,
        structuredData: buildTaxiServiceSchema({
          pageUrl: canonicalUrl,
          name: title,
          description,
          image: `${CLIENT_BASE_PATH}/assets/img/banner.jpg`,
        }),
      }
    );
  }, []);

  const handleItemClick = (index: number) => {
    setSelectedItems((prevSelectedItems) => {
      const updatedSelectedItems = [...prevSelectedItems];
      updatedSelectedItems[index] = !updatedSelectedItems[index];
      return updatedSelectedItems;
    });
  };

  const handlePackagesFilter = (index: any, vehicle_type: any) => {
    setActiveIndex(index);
    setActiveVehicleType(vehicle_type ? String(vehicle_type) : "");
    setOffersPage(1);
    fetchPackagesList(vehicle_type);
  };

  useEffect(() => {
    if (offersPage > totalOffersPages) {
      setOffersPage(totalOffersPages);
    }
  }, [offersPage, totalOffersPages]);

  useEffect(()=>{
    fetchPackagesPrice()
  },[selectedVehicle,selectedPickupLocation,selectedDropLocation])

  const fetchPackagesPrice = async () => {
    try {
      const payload ={
        pickup_location: selectedPickupLocation?selectedPickupLocation:'',
        drop_location: selectedDropLocation?selectedDropLocation:'',
        vehicle_detail: selectedVehicle?selectedVehicle:''

      }
      const response = await axios.post(`${API_BASE_URL}/packages/list`, {
         payload,
      });
      setPackagePriceData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (activeIndex === null) {
      handlePackagesFilter(0, "");
    }
  }, [activeIndex]);
  const carTypesSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };


  const routesSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  const fetchCarsTypeList = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/vehicles_type/list`);
      setPopularCartTypes(getArrayPayload(response.data));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchVehicleTypeList = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/vehicles/list`);
      setVehicleTypeList(getArrayPayload(response.data));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchPackagesList = async (make: string) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/packages/list`, {
        vehicle_type: make,
      });
      setPackagesList(getArrayPayload(response.data));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchLocationsList = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/locations/list`);
      setLocationsList(getArrayPayload(response.data));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchVehicleTypeList();
    fetchCarsTypeList();
    fetchPackagesList("");
    fetchLocationsList();
  }, []);

  const validationSchema = Yup.object().shape({
    vehicle_id: Yup.string().required("اختر سيارة"),
    pickup_location_id: Yup.string().required("اختر موقع الاستلام"),
    drop_location_id: Yup.string().required("اختر موقع التوصيل"),
    pickup_date_time: Yup.string().required("اختر تاريخ ووقت الاستلام"),
    phone_no: Yup.string().required("يرجى إدخال رقم الهاتف"),
    name: Yup.string(),
    email: Yup.string().required("يرجى إدخال البريد الإلكتروني"),
  });

  const defaultValues = {
    vehicle_id: "",
    pickup_location_id: "",
    drop_location_id: "",
    pickup_date_time: "",
    phone_no: "",
    name: "",
    email: "",
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset:formReset,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues,
  });

  const onSubmit = async (data: any) => {
    setIsBookingModalOpen(true);
    setIsLoading(true);
    setSuccessMessage("");
    setErrorMessage("");
    try {
      const payload = {
        vehicle_id: data.vehicle_id,
        pickup_location_id: data.pickup_location_id,
        drop_off_location_id: data.drop_location_id,
        pickup_date_time: data.pickup_date_time,
        phone_no: data.phone_no,
        name: data.name ? data.name : "",
        baby_seat: false,
        email: data.email ? data.email : "",
        user_id: "",
      };
      const response = await axios.post(`${API_BASE_URL}/booking/add`, payload);

      if (response.status == 201 || response.status == 200) {
        setErrorMessage("");
        setSuccessMessage(response.data.message);

        setIsLoading(false);
      } else {
        setErrorMessage(response.data.message);
        setSuccessMessage("");
        setIsLoading(false);
      }
    } catch (error: any) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setErrorMessage(error.response.data.message);
        setSuccessMessage("");
        setIsLoading(false);
      } else {
        setErrorMessage("حدث خطأ. يرجى المحاولة مرة أخرى لاحقاً.");
        setIsLoading(false);
      }
    }
    finally {
      formReset();
    }
  };

  const handleBookingPackages = (bookingData: any) => {
    setConfirmBookingData(bookingData);
    setShowBookingDetails(false);
    reset({
      name: displayName || "عميل",
      email: userEmail,
      phone_no: userPhone || "غير متوفر",
      pickup_date_time1: null,
    });
    setBookingConfirmToggle(true);
  };

  const handleAddToCart = (bookingData: any) => {
    addCartItem(packageToCartItem(bookingData));
    setCartMessage(`تمت إضافة ${bookingData?.vehicle_detail?.name || "الباقة"} إلى السلة.`);
    window.setTimeout(() => setCartMessage(""), 3000);
  };

  const closeBookingModal = () => {
    setIsBookingModalOpen(false);
  };
  const closePackagesBooking = () => {
    setBookingConfirmToggle(false);
    setConfirmBookingData([]);
  };

  const schemaWithPersonalDetails = Yup.object().shape({
    name: Yup.string().required("الاسم مطلوب"),
    email: Yup.string()
      .email("بريد إلكتروني غير صالح")
      .required("البريد الإلكتروني مطلوب"),
    pickup_date_time1: Yup.string().required("اختر تاريخ ووقت الاستلام"),
    phone_no: Yup.string().required("رقم الهاتف مطلوب"),
  });

  const {
    handleSubmit: handlePackageSubmit,
    control: handleController,
    formState: { errors: personalDetailsErrors },
    reset,
  } = useForm({
    resolver: yupResolver(schemaWithPersonalDetails),
  });

  const onSubmitPersonalDetails = async (bookingFormData: any) => {
    setIsLoading(true);
    try {
      const payload = {
        package_id: confirmBookingData.id,
        pickup_date_time: bookingFormData.pickup_date_time1,
        phone_no: isLoggedIn ? userPhone || bookingFormData.phone_no || "N/A" : bookingFormData.phone_no,
        name: isLoggedIn ? displayName || bookingFormData.name || "عميل" : bookingFormData.name,
        email: isLoggedIn ? userEmail : bookingFormData.email,
        user_id: isLoggedIn ? user?.id || user?.userId || "" : "",
        baby_seat: confirmBookingData.vehicle_detail.baby_seat,
      };
      const response = await axios.post(
        `${API_BASE_URL}/booking/add`,
        payload
      );
      if (response.status == 201 || response.status == 200) {
        setBookingConfirmToggle(false);
        setIsBookingModalOpen(true);
        setErrorMessage("");
        setSuccessMessage(response.data.message);
        setIsLoading(false);
      } else {
        setBookingConfirmToggle(false);
        setIsBookingModalOpen(true);
        setErrorMessage(response.data.message);
        setSuccessMessage("");
        setIsLoading(false);
      }
    } catch (error: any) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setErrorMessage(error.response.data.message);
        setBookingConfirmToggle(false);
        setIsBookingModalOpen(true);
        setSuccessMessage("");
        setIsLoading(false);
      } else {
        setBookingConfirmToggle(false);
        setIsBookingModalOpen(true);
        setErrorMessage("حدث خطأ. يرجى المحاولة مرة أخرى لاحقاً.");
        setIsLoading(false);
      }
    } finally {
      setConfirmBookingData([]);
      reset();
    }
  };

  return (
    <>
      {isBookingModalOpen && (
        <div
          className={` ${isloading ? "pointer-event-none" : ""} modal new-modal fade d-block show`}
          id="delete_modal"
          data-keyboard="false"
          data-backdrop="static"
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="delete-action">
                  <div className="delete-header">
                    <h4>حالة الحجز</h4>
                  </div>
                  {isloading && (
                    <p className="py-4">
                      يرجى الانتظار، حجزك قيد التنفيذ ...
                    </p>
                  )}
                  {successMessage && (
                    <p className="py-4 text-success">{successMessage}</p>
                  )}
                  {errorMessage && (
                    <p className="py-4 text-danger">{errorMessage}</p>
                  )}

                  <div className="modal-btn">
                    <div className="row">
                      <div className="col-6 m-auto">
                        <button
                          onClick={closeBookingModal}
                          className="btn btn-primary w-100"
                        >
                          إغلاق
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isBookingModalOpen && <div className="modal-backdrop fade show"></div>}
      {bookingConfirmToggle && (
        <div
          className={` ${isloading ? "pointer-event-none" : ""} modal new-modal multi-step booking-confirm-modal fade d-block show`}
          id="complete_booking"
          data-keyboard="false"
          data-backdrop="static"
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <form onSubmit={handlePackageSubmit(onSubmitPersonalDetails)}>
              <div className="modal-content">
                <div className="modal-header" onClick={closePackagesBooking}>
                  <button
                    type="button"
                    className="close-btn"
                    data-bs-dismiss="modal"
                  >
                    <span>×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="booking-header">
                    <div className="booking-img-wrap">
                      <div className="book-img">
                        <img
                          src="https://dev.alharamaincab.com/assets/img/cars/carImage.png"
                          alt="img"
                        />
                      </div>
                      <div className="book-info">
                        <h6>{confirmBookingData?.vehicle_detail?.name}</h6>
                        <p>
                          <i className="feather-map-pin" /> من{" "}
                          {confirmBookingData?.pickup_location?.name} {" إلى "}{" "}
                          {confirmBookingData?.drop_location?.name}
                        </p>
                      </div>
                    </div>
                    <div className="book-amount">
                      <p>المبلغ الإجمالي</p>
                      <h6>{formattedTotalAmount}</h6>
                    </div>
                  </div>
                  <div className="booking-group">
                    <div className="booking-wrapper">
                      <button
                        type="button"
                        className="booking-details-toggle"
                        onClick={() => setShowBookingDetails((current) => !current)}
                      >
                        <span>تفاصيل الحجز</span>
                        <i className={`feather-chevron-${showBookingDetails ? "up" : "down"}`} />
                      </button>
                      {showBookingDetails && (
                      <div className="row">
                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>نوع الحجز</h6>
                            <p>حجز باقة</p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>موقع الاستلام</h6>
                            <p>{confirmBookingData?.pickup_location?.name}</p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>موقع التوصيل</h6>
                            <p>{confirmBookingData?.drop_location?.name}</p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>عدد الرحلات</h6>
                            <p>
                              {confirmBookingData?.vehicle_detail?.total_rides}
                            </p>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>مقعد طفل</h6>
                            <p>
                              {confirmBookingData?.vehicle_detail?.baby_seat ===
                              true
                                ? "نعم"
                                : "لا"}
                            </p>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>سعة الركاب</h6>
                            <p>
                              {
                                confirmBookingData?.vehicle_detail
                                  ?.passenger_capacity
                              }
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>سعة الأمتعة</h6>
                            <p>
                              {
                                confirmBookingData?.vehicle_detail
                                  ?.luggage_capacity
                              }
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>نوع الوقود</h6>
                            <p>
                              {confirmBookingData?.vehicle_detail?.fuel_type}
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>تاريخ ووقت الاستلام</h6>
                            <p>{confirmBookingData?.pickup_date_time}</p>
                          </div>
                        </div>
                      </div>
                      )}
                    </div>

                    <div className="booking-wrapper">
                      <div className="booking-title">
                        <h6>{isLoggedIn ? "وقت الاستلام" : "بياناتك"}</h6>
                      </div>
                      <div className="row">
                        {isLoggedIn ? (
                          <div className="col-12">
                            <div className="booking-account-note">
                              <i className="feather-user-check" />
                              <div>
                                <strong>{displayName || userEmail}</strong>
                                <span>{userEmail}</span>
                              </div>
                            </div>
                          </div>
                        ) : (
                        <>
                        <div className="col-12">
                          <div className="input-block">
                            <label>الاسم</label>
                            <div className="group-img">
                              <Controller
                                name="name"
                                control={handleController}
                                render={({ field }) => (
                                  <>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="أدخل الاسم"
                                      {...field}
                                    />
                                  </>
                                )}
                              />
                            </div>
                            {personalDetailsErrors.name && (
                              <p className="text-danger pt-1">
                                {personalDetailsErrors.name.message}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="input-block">
                            <label>البريد الإلكتروني</label>
                            <div className="group-img">
                              <Controller
                                name="email"
                                control={handleController}
                                render={({ field }) => (
                                  <>
                                    <input
                                      type="email"
                                      className="form-control"
                                      placeholder="أدخل البريد الإلكتروني"
                                      {...field}
                                    />
                                  </>
                                )}
                              />
                            </div>
                            {personalDetailsErrors.email && (
                              <p className="text-danger pt-1">
                                {personalDetailsErrors.email.message}
                              </p>
                            )}
                          </div>
                        </div>
                        </>
                        )}

                        <div className="col-12">
                          <div className="column-group-main">
                            <div className="input-block">
                              <label>تاريخ ووقت الاستلام</label>
                            </div>
                            <div className="input-block-wrapp">
                              <div className="input-block date-widget">
                                <div className="group-img">
                                  <Controller
                                    name="pickup_date_time1"
                                    control={handleController}
                                    render={({ field }) => (
                                      <DatePicker
                                        selected={
                                          field.value
                                            ? new Date(field.value)
                                            : null
                                        }
                                        onChange={(date) =>
                                          field.onChange(date)
                                        }
                                        showTimeSelect
                                        dateFormat="yyyy-MM-dd HH:mm"
                                        placeholderText="اختر التاريخ والوقت"
                                        className="form-control"
                                        timeInputLabel="الوقت:"
                                      />
                                    )}
                                  />
                                  {personalDetailsErrors.pickup_date_time1 && (
                                    <p className="text-danger pt-1">
                                      {
                                        personalDetailsErrors.pickup_date_time1
                                          .message
                                      }
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {!isLoggedIn && (
                        <div className="col-12">
                          <div className="search-box-banner p-0 m-0">
                            <div className="input-block column-group-main max-width-100">
                              <label>رقم الهاتف</label>
                              <div className="phone-input-style PhoneInput">
                                <Controller
                                  name="phone_no"
                                  control={handleController}
                                  defaultValue=""
                                  render={({ field }) => (
                                    <PhoneNumberField
                                      onChange={field.onChange}
                                    />
                                  )}
                                />
                              </div>
                              {personalDetailsErrors.phone_no && (
                                <p className="text-danger pt-1">
                                  {personalDetailsErrors.phone_no.message}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="modal-btn modal-btn-sm text-end">
                    <button
                      onClick={closePackagesBooking}
                      disabled={isloading ? true : false}
                      className="btn btn-secondary"
                    >
                      إلغاء
                    </button>
                    <button
                      disabled={isloading ? true : false}
                      type="submit"
                      className="btn btn-primary"
                    >
                      {isloading ? "يرجى الانتظار" : "تأكيد"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
      {bookingConfirmToggle && <div className="modal-backdrop fade show"></div>}

      <section className="banner-section banner-slider">
        <div className="container">
          <div className="home-banner">
            <div className="row align-items-center mb-5 relative hero-section-block">
              <div className="col-lg-4" data-aos="fade-down">
                <h2 className="mb-5">
                  مرحباً بكم في <br />
                  <span className="primary-color">الحرمين كاب</span>
                </h2>
              </div>
              <div className="col-lg-4 text-center banner-imgs">
                <div className="banner-imgs banner-center-image">
                  <ImageWithBasePath
                    src="assets/img/gallery/hero-payment.png"
                    className="img-fluid aos"
                    alt="bannerimage"
                    width={145}
                    height={145}
                  />
                  <div className="centered-text text-primary">
                    <p>ريال</p>
                    <p>{packagePriceData[0]?.price?packagePriceData[0]?.price:'150'}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 text-right">
                <div className="banner-imgs banner-right-image">
                  <ImageWithBasePath
                    src="assets/img/gallery/heroCars.png"
                    className="img-fluid aos"
                    alt="bannerimage"
                    width={290}
                    height={186}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-search">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="container">
              <div className="search-box-banner">
                <ul className="align-items-center">
                  <li className="column-group-main">
                    <div className="input-block">
                      <label htmlFor="vehicle_id">
                        اختر وسيلة النقل{" "}
                        {errors.vehicle_id && (
                          <span className="p-1 text-danger">
                            {errors.vehicle_id.message}
                          </span>
                        )}
                      </label>

                      <div className="group-img">
                        <Controller
                          name="vehicle_id"
                          control={control}
                          defaultValue=""

                          render={({ field }) => (
                            <select
                              {...field}
                              id="vehicle_id"
                              className="form-control"
                              onChange={(e:any) => {
                                setSelectedVehicle(e.target.value);
                                field.onChange(e);
                              }}
                            >
                              <option value="">اختر وسيلة</option>
                              {vehicleTypeList.map((item: any, index) => (
                                <option key={index} value={item.id}>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          )}
                        />
                        <span>
                          <i className="fa-solid fa-taxi" />
                        </span>
                      </div>
                    </div>
                  </li>

                  <li className="column-group-main">
                    <div className="input-block">
                      <label htmlFor="pickup_location_id">
                        موقع الاستلام{" "}
                        {errors.pickup_location_id && (
                          <span className="p-1 text-danger">
                            {errors.pickup_location_id.message}
                          </span>
                        )}
                      </label>
                      <div className="group-img">
                        <Controller
                          name="pickup_location_id"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <select
                              {...field}
                              id="pickup_location_id"
                              className="form-control"
                              onChange={(e:any) => {
                                setSelectedPickupLocation(e.target.value);
                                field.onChange(e);
                              }}
                            >
                              <option value="">
                                اختر مدينة أو مطار أو فندق
                              </option>
                              {locationsList.map((item: any, index) => (
                                <option key={index} value={item.id}>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          )}
                        />
                        <span>
                          <i className="feather icon-map-pin" />
                        </span>
                      </div>
                    </div>
                  </li>

                   <li className="column-group-main">
                    <div className="input-block">
                      <label htmlFor="drop_location_id">
                        وجهة الرحلة
                        {errors.drop_location_id && (
                          <span className="p-1 text-danger">
                            {errors.drop_location_id.message}
                          </span>
                        )}
                      </label>
                      <div className="group-img">
                        <Controller
                          name="drop_location_id"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <select
                              {...field}
                              id="drop_location_id"
                              className="form-control"
                              onChange={(e:any) => {
                                setSelectedDropLocation(e.target.value);
                                field.onChange(e);
                              }}
                            >
                              <option value="">
                                اختر مدينة أو مطار أو فندق
                              </option>
                              {locationsList.map((item: any, index) => (
                                <option key={index} value={item.id}>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          )}
                        />
                        <span>
                          <i className="feather icon-map-pin" />
                        </span>
                      </div>
                    </div>
                  </li>

                  <li className="column-group-main">
                    <div className="input-block">
                      <label htmlFor="pickup_date_time">
                        تاريخ الاستلام{" "}
                        {errors.pickup_date_time && (
                          <span className="p-1 text-danger">
                            {errors.pickup_date_time.message}
                          </span>
                        )}
                      </label>
                    </div>
                    <div className="input-block-wrapp">
                      <div className="input-block date-widget">
                        <div className="group-img">
                          <Controller
                            name="pickup_date_time"
                            control={control}
                            render={({ field }) => (
                              <DatePicker
                                selected={
                                  field.value ? new Date(field.value) : null
                                }
                                onChange={(date) => field.onChange(date)}
                                showTimeSelect
                                dateFormat="yyyy-MM-dd HH:mm"
                                placeholderText="اختر التاريخ والوقت"
                                className="form-control"
                                timeInputLabel="الوقت:"
                              />
                            )}
                          />
                          <span>
                            <i className="feather icon-calendar"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li className="column-group-main">
                    <div className="input-block">
                      <label>
                        رقم الهاتف
                        {errors.phone_no && (
                          <span className="p-1 text-danger">
                            {errors.phone_no.message}
                          </span>
                        )}
                      </label>
                      <div className="phone-input-style PhoneInput">
                        <Controller
                          name="phone_no"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <PhoneNumberField onChange={field.onChange} />
                          )}
                        />
                      </div>
                    </div>
                  </li>

                  <li className="column-group-main">
                    <div className="input-block">
                      <label>
                        البريد الإلكتروني
                        {errors.email && (
                          <span className="p-1 text-danger">
                            {errors.email.message}
                          </span>
                        )}
                      </label>
                      <div className="group-img">
                        <Controller
                          name="email"
                          control={control}
                          render={({ field }) => (
                            <>
                              <input
                                type="email"
                                className="form-control"
                                placeholder="أدخل البريد الإلكتروني"
                                {...field}
                              />
                            </>
                          )}
                        />

                        <span>
                          <i className="fa-regular fa-user" />
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="view-all text-center pt-4">
                <button
                  type="submit"
                  className="py-4 btn btn-view align-items-center hero-book-btn"
                >
                  {isloading ? "يرجى الانتظار" : "احجز الآن!"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </section>

      <section className="section popular-services popular-explore pt-0">
        <div className="container">
          <div className="section-heading" data-aos="fade-down">
            <h2>اكتشف أكثر العروض شيوعاً</h2>
            <p>
              اكتشف أكثر عروض خدمة الحرمين كاب شيوعاً، والتي تهم المعتمرين والحجاج بشكل خاص
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-12" data-aos="fade-down">
              <div className="listing-tabs-group">
                <ul className="nav listing-buttons gap-3">
                  <li>
                    <div
                      className={`carttypestabs ${!activeVehicleType ? "active" : ""}`}
                      onClick={() => handlePackagesFilter(-1, "")}
                    >
                      <span>
                        <ImageWithBasePath
                          src="assets/img/gallery/sedan-icon.svg"
                          alt="vehicle type"
                        />
                      </span>
                      الكل
                    </div>
                  </li>
                  {displayCartTypes?.map((item: any, index) => (
                    <li key={index}>
                      <div
                        className={`carttypestabs ${activeVehicleType === String(item.id) ? "active" : ""}`}
                        onClick={() => handlePackagesFilter(index, item.id)}
                      >
                        <span>
                          <ImageWithBasePath
                            src={item.icon}
                            alt="vehicle type"
                          />
                        </span>
                        {item.name}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="tab-content">
            <div className="tab-pane active">
              <div className="row">
                {paginatedPackagesList.length > 0 ? (
                  <>
                    {paginatedPackagesList.length > 0 &&
                      paginatedPackagesList
                        .map((item: any, index: number) => (
                          <>
                            <div
                              className="col-lg-4 col-md-6 col-12 text-center"
                              data-aos="fade-down"
                              key={index}
                            >
                              <div className="listing-item">
                                <div className="listing-img">
                                  <Link
                                    to={getPackageUrl(item)}
                                  >
                                    <ImageWithBasePath
                                      src={item?.image}
                                      className="img-fluid"
                                      alt="Toyota"
                                    />
                                  </Link>
                                  <div
                                    className="fav-item"
                                    key={1}
                                    onClick={() => handleItemClick(1)}
                                  >
                                    <span className="featured-text">
                                      {item?.groupedVehicleTypeNames?.join(", ") || item?.vehicle_detail.vehicle_type?.name}
                                    </span>
                                    <Link
                                      to={getPackageUrl(item)}
                                      className={`fav-icon ${
                                        selectedItems[1] ? "selected" : ""
                                      }`}
                                    >
                                      <i className="feather icon-heart" />
                                    </Link>
                                  </div>
                                </div>
                                <div className="listing-content">
                                  <div className="listing-features">
                                    <Link
                                      to={getPackageUrl(item)}
                                      className="author-img"
                                    >
                                      <ImageWithBasePath
                                        src={
                                          item?.vehicle_detail?.vehicle_type
                                            ?.icon
                                        }
                                        alt="author"
                                      />
                                    </Link>
                                    <h3 className="listing-title">
                                      <Link to={getPackageUrl(item)}>
                                        {item?.name}
                                      </Link>
                                    </h3>
                                    <div className="list-rating">
                                      <span className="featured-text">
                                        {item?.routeLabel}
                                      </span>
                                    </div>
                                    {item?.groupedVehicleNames?.length > 0 && (
                                      <div className="package-vehicle-list">
                                        {item.groupedVehicleNames.map((vehicleName: string) => (
                                          <span key={vehicleName}>{vehicleName}</span>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                  <div className="listing-details-group">
                                    <ul>
                                      <li>
                                        <span>
                                          <ImageWithBasePath
                                            src={
                                              item?.vehicle_detail?.vehicle_type
                                                ?.connectivity_icon
                                            }
                                            alt="Auto"
                                          />
                                        </span>
                                        <p>
                                          {
                                            item?.vehicle_detail?.vehicle_type?.connectivity
                                          }
                                        </p>
                                      </li>
                                      <li>
                                        <span>
                                          <ImageWithBasePath
                                            src={
                                              item?.vehicle_detail
                                                .luggage_capacity_icon
                                            }
                                            alt="10 KM"
                                          />
                                        </span>
                                        <p>
                                          {
                                            item?.vehicle_detail
                                              ?.luggage_capacity
                                          }
                                        </p>
                                      </li>
                                      <li>
                                        <span>
                                          <ImageWithBasePath
                                            src={
                                              item?.vehicle_detail?.disabled_icon
                                            }
                                            alt="diabled"
                                          />
                                        </span>
                                        <p>{item?.vehicle_detail?.disabled===1?"نعم":"لا"}</p>
                                      </li>
                                    </ul>
                                    <ul>
                                      <li>
                                        <span>
                                          <ImageWithBasePath
                                            src={
                                              item?.vehicle_detail?.vehicle_type
                                                ?.comfort_icon
                                            }
                                            alt="confort"
                                          />
                                        </span>
                                        <p>
                                          {
                                            item?.vehicle_detail?.vehicle_type?.comfort
                                          }
                                        </p>
                                      </li>
                                      <li>
                                        <span>
                                          <ImageWithBasePath
                                            src={
                                              item?.vehicle_detail?.vehicle_type
                                                ?.safety_icon
                                            }
                                            alt=""
                                          />
                                        </span>
                                        <p>
                                          {
                                            item?.vehicle_detail?.vehicle_type?.safety
                                          }
                                        </p>
                                      </li>
                                      <li>
                                        <span>
                                          <ImageWithBasePath
                                            src={
                                              item?.vehicle_detail
                                                .passenger_capacity_icon
                                            }
                                            alt="Persons"
                                          />
                                        </span>
                                        <p>
                                          {
                                            item?.vehicle_detail
                                              ?.passenger_capacity
                                          }
                                        </p>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="listing-location-details justify-content-center">
                                    <div className="listing-price text-center">
                                      <h6>{item?.price} ريال</h6>
                                    </div>
                                  </div>
                                  <div className="listing-button">
                                    <button
                                      onClick={() => handleAddToCart(item)}
                                      className="btn btn-outline-primary btn-cart"
                                      type="button"
                                    >
                                      <i className="feather-shopping-cart" /> أضف إلى السلة
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleBookingPackages(item)
                                      }
                                      className="btn btn-order"
                                    >
                                      {isloading ? "يرجى الانتظار" : "احجز الآن"}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        ))}
                    {totalOffersPages > 1 && (
                      <div className="col-12">
                        <nav className="popular-offers-pagination" aria-label="Popular offers pagination">
                          <button
                            type="button"
                            className="popular-page-btn"
                            disabled={offersPage === 1}
                            onClick={() => setOffersPage(page => Math.max(1, page - 1))}
                          >
                            السابق
                          </button>
                          {Array.from({ length: totalOffersPages }, (_, pageIndex) => {
                            const pageNumber = pageIndex + 1;
                            return (
                              <button
                                key={pageNumber}
                                type="button"
                                className={`popular-page-number ${offersPage === pageNumber ? "active" : ""}`}
                                onClick={() => setOffersPage(pageNumber)}
                              >
                                {pageNumber}
                              </button>
                            );
                          })}
                          <button
                            type="button"
                            className="popular-page-btn"
                            disabled={offersPage === totalOffersPages}
                            onClick={() => setOffersPage(page => Math.min(totalOffersPages, page + 1))}
                          >
                            التالي
                          </button>
                        </nav>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <div className="col-lg-4 col-md-6 col-12 text-center">
                      <ProductCardLoader />
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 text-center">
                      <ProductCardLoader />
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 text-center">
                      <ProductCardLoader />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        </section>
        {cartMessage && (
          <div className="cart-toast" role="status">
            <i className="feather-check-circle" />
            <span>{cartMessage}</span>
            <Link to={routes.bookingcheckout}>إتمام الشراء</Link>
          </div>
        )}

      <section className="section popular-car-type">
        <div className="container">
          <div className="section-heading" data-aos="fade-down">
            <h2>أكثر السيارات طلباً</h2>
            <p>
              استمتع بسيارات مريحة في رحلتك إلى مكة والمدينة مع الحرمين
            </p>
          </div>
          {displayCartTypes.length > 0 ? (
            <>
               <div className="row">
            <div className="popular-slider-group">
              <Slider {...carTypesSettings}>
                {displayCartTypes?.map((item: any, index) => (
                  <div className="listing-owl-item" key={index}>
                    <div className="listing-owl-group">
                      <div className="listing-owl-img">
                        <ImageWithBasePath
                          src={item.image}
                          className="img-fluid"
                          alt="Popular Cartypes"
                        />
                      </div>
                      <h6>{item.name}</h6>
                      <p>ابتداءً من 150 ريال</p>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
            </>
          ) : (
            <>
               <div className="row">
            <div className="popular-slider-group">
              <Slider {...carTypesSettings}>
                {[...Array(5)].map((_, i) => (
                  <div className="listing-owl-item" key={i}>
                    <CardIconLoader />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
            </>
          )}
        </div>
      </section>

      <section className="section facts-number">
        <div className="facts-left">
          <ImageWithBasePath
            src="assets/img/bg/facts-left.png"
            className="img-fluid"
            alt="facts left"
          />
        </div>
        <div className="facts-right">
          <ImageWithBasePath
            src="assets/img/bg/facts-right.png"
            className="img-fluid"
            alt="facts right"
          />
        </div>
        <div className="container">
          <div className="counter-group">
            <div className="row">
              <div
                className="col-lg-6 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="flex-fill m-auto text-end whatsapp-section">
                  <div className="">
                    <h2 className="title text-white">احجز سيارتك</h2>
                    <h2 className="title text-white">
                      {" "}
                      ب{" "}
                      <span className="text-primary text-30">أسهل طريقة</span>
                    </h2>
                    <h2 className="title text-white">عبر واتساب</h2>
                    <div className="view-all pt-3">
                      <a
                        href="https://wa.me/966580125300"
                        className="py-4 border-0 btn w-50 btn-view align-items-right"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        احجز الآن!
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-6 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className=" flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <ImageWithBasePath
                      src="assets/img/cars/whatsapp-phone.png"
                      alt=""
                      className="m-auto whatsapp-section-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section popular-car-type">
        <div className="container">
          <div className="section-heading" data-aos="fade-down">
            <h2>أكثر المسارات طلباً</h2>
            <p>اكتشف أكثر مساراتنا طلباً لرحلتك</p>
          </div>

          {locationsList.length > 0 ? (
            <>
              <div className="row">
                <div className="popular-slider-group popular-routes">
                  <Slider {...routesSettings}>
                    {locationsList.map((item: any, index) => (
                      <>
                        <div className="listing-owl-item" key={index}>
                          <div className="listing-owl-group">
                            <div className="listing-owl-img">
                              <ImageWithBasePath
                                src="assets/img/gallery/Route.svg"
                                className="img-fluid"
                                alt="Popular Cartypes"
                              />
                            </div>
                            <h6>{item?.name}</h6>
                            <p>ابتداءً من 150</p>
                          </div>
                        </div>
                      </>
                    ))}
                  </Slider>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="row">
                <div className="popular-slider-group">
                  <Slider {...routesSettings}>
                    <div className="listing-owl-item">
                      <CardIconLoader />
                    </div>
                    <div className="listing-owl-item">
                      <CardIconLoader />
                    </div>
                    <div className="listing-owl-item">
                      <CardIconLoader />
                    </div>
                    <div className="listing-owl-item">
                      <CardIconLoader />
                    </div>
                    <div className="listing-owl-item">
                      <CardIconLoader />
                    </div>
                  </Slider>
                </div>
              </div>
            </>
          )}
        </div>
      </section>

      <section className="section services">
        <div className="service-right">
          <ImageWithBasePath
            src="assets/img/bg/service-right.svg"
            className="img-fluid"
            alt="services right"
          />
        </div>
        <div className="container">
          <div className="section-heading" data-aos="fade-down">
            <h2>كيف تعمل الخدمة</h2>
            <p>
              تُبسّط الحرمين كاب رحلة حجكم أو عمرتكم بالتركيز على الراحة والأمان
              والسكينة الروحية. هكذا تعمل خدمتنا بخطوات بسيطة
            </p>
          </div>
          <div className="services-work">
            <div className="row">
              <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                <div className="services-group">
                  <div className="services-icon border-secondary">
                    <ImageWithBasePath
                      className="icon-img bg-secondary"
                      src="assets/img/icons/services-icon-01.svg"
                      alt="Book Your Ride"
                    />
                  </div>
                  <div className="services-content">
                    <h3>1. احجز رحلتك</h3>
                    <p>
                      استخدم موقعنا أو تطبيق الهاتف لاختيار تفاصيل رحلتك.
                      اختر التاريخ والوقت والوجهة لرحلتك.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                <div className="services-group">
                  <div className="services-icon border-warning">
                    <ImageWithBasePath
                      className="icon-img bg-warning"
                      src="assets/img/icons/services-icon-02.svg"
                      alt="Receive Confirmation"
                    />
                  </div>
                  <div className="services-content">
                    <h3>2. استلم التأكيد</h3>
                    <p>
                      ستحصل على رسالة تأكيد تحتوي على تفاصيل السائق والوقت المتوقع
                      للوصول. تضمن هذه الرسالة أن كل شيء جاهز لرحلتك.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                <div className="services-group">
                  <div className="services-icon border-dark">
                    <ImageWithBasePath
                      className="icon-img bg-dark"
                      src="assets/img/icons/services-icon-03.svg"
                      alt="Enjoy Your Journey"
                    />
                  </div>
                  <div className="services-content">
                    <h3>3. استمتع برحلتك</h3>
                    <p>
                      سيصل سائقك في الوقت المحدد، جاهزاً لأخذك إلى وجهتك. الرحلة
                      مريحة وآمنة وتحترم تجربة حجك أو عمرتك.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section container">
        <div className="user-app-group">
          <div className="app-left">
            <ImageWithBasePath
              src="assets/img/bg/app-left.png"
              className="img-fluid"
              alt="App Available"
            />
          </div>
          <div className="app-right">
            <ImageWithBasePath
              src="assets/img/bg/app-right.png"
              className="img-fluid"
              alt="App Available"
            />
          </div>
          <div className="row">
            <div className="col-lg-7">
              <div className="userapp-heading">
                <h2 data-aos="fade-down mb-3">
                  رحلة حج وعمرة سلسة مع خدمة الحرمين كاب
                </h2>
                <p data-aos="fade-down">
                  استمتع بالراحة والأمان والتوجيه الروحي مع خدمة الحرمين كاب.
                  سائقونا المحترفون ووسائل نقلنا المتميزة تضمن رحلة سلسة.
                </p>
                <div className="download-btn">
                  <div className="app-avilable" data-aos="fade-down">
                  </div>
                  <div className="app-avilable" data-aos="fade-down">
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 d-none d-lg-block">
              <div className="car-holder">
                <ImageWithBasePath
                  className="app-car img-fluid"
                  src="assets/img/gallery/app-car.jpg"
                  alt="App Available"
                  width={368}
                  height={246}
                  data-aos="fade-down"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ArHome;
